import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { enGB, es, pt } from "date-fns/locale";
import "../../css/rsuite-timerange-scope.css";
import TimeRangePicker from "../inputs/TimeRangePicker";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Loader from "../Loader";
import { api } from "../../App";
import { fetchOpenClosedExceptions, createOpenClosedExceptions, fetchRestaurantDetails } from "../../actions/restaurantActions";
import styled from "styled-components";
import DropDownButton from "../DropDownButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import CustomSelectArray from "../CustomSelectArray";
import { ModernButton, InlineText, InsideFormGroup, FormGroup, Input, StyledLabel } from "../../components/DefaultImports";
import { ConfirmationModal } from "../ConfirmationModal";
import { hasCompletoFeatures } from "../../utils/planFeatures";
const StyledDateRangePicker = styled(DateRangePicker)`
  width: auto;
  margin: 0 auto;
  border-radius: 10px;

  .rdrDefinedRangesWrapper {
    display: none;
  }

  .rdrInRange {
    background: #f79574 !important;
    color: #333 !important;
  }

  .rdrStartEdge,
  .rdrEndEdge {
    background-color: #ff704d !important;
    color: white !important;
  }

  .rdrDayStartPreview,
  .rdrDayEndPreview {
    color: #ff704d !important;
  }

  .rdrDayInPreview {
    color: #ff704d !important;
  }

  .rdrDayNumber span::after {
    background-color: #ff704d !important;
  }

  .rdrMonthAndYearPickers select {
    font-size: 14px;
    color: #4b3335;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 4px 6px;
    height: 30px;
    min-width: 100px;
    text-align: center;
    appearance: none;
  }

  .rdrMonthAndYearPickers option {
    font-size: 16px;
    color: #4b3335;
    text-align: center;
    padding: 6px;
  }

  .rdrMonthAndYearPickers {
    gap: 12px;
    justify-content: center;
    align-items: center;
  }
`;
const BlockedInputWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  input {
    padding-right: ${({
  $blocked
}) => $blocked ? "34px" : undefined};

    ${({
  $blocked
}) => $blocked ? `
          cursor: pointer;
          border-color: #ee754c !important;
          background-color: #fff7f4 !important;
          box-shadow: 0 0 0 1px rgba(238, 117, 76, 0.18);
        ` : ""}
  }
`;
const BlockedInputOverlay = styled.span`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #ee754c;
  cursor: pointer;
  border-radius: 6px;

  svg {
    filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.85));
  }
`;
const OpenClosedExceptions = ({
  restaurant_id,
  type_of_exception,
  exception_id,
  mode,
  setShowModal
}) => {
  const { t, i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const dateLocale = language === "pt" ? pt : language === "es" ? es : enGB;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const restaurantDetails = useSelector(state => state.restaurantDetails);
  const {
    restaurants
  } = restaurantDetails;
  const restaurantZones = useSelector(state => state.restaurantZones);
  const {
    zones = []
  } = restaurantZones;
  const openClosedExceptions = useSelector(state => state.openClosedExceptions);
  const {
    exceptions
  } = openClosedExceptions;
  const [isFormReady, setIsFormReady] = useState(false);
  const [zone_list, setZone_list] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [accept_people_per_each_time, setAaccept_people_per_each_time] = useState(20);
  const [eachTime, setEachTime] = useState("00:15");
  const [showExceptionDaysDeleteModal, setShowExceptionDaysDeleteModal] = useState(false);
  const [showArrivalControlUpgradeModal, setShowArrivalControlUpgradeModal] = useState(false);
  const [switchLimit, setSwitchLimit] = useState(false);
  const [switchZones, setSwitchZones] = useState(mode === "create" ? false : true);
  const [dateRange, setDateRange] = useState([{
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
  }]);
  const [formData, setFormData] = useState({
    restaurant: parseInt(restaurant_id),
    closed_days_start: formatDate(new Date()),
    closed_days_end: formatDate(new Date()),
    start_time: "12:00",
    end_time: "18:00",
    list_of_zones: "",
    accept_people_per_each_time: 20,
    each_time: "00:15",
    type_of_exception
  });
  const isCurrentRestaurantLoaded = restaurants && Number(restaurants.id) === Number(restaurant_id);
  const isArrivalControlBlocked =
    !isCurrentRestaurantLoaded || !hasCompletoFeatures(restaurants);
  const displayedArrivalLimit = isArrivalControlBlocked ? "" : accept_people_per_each_time;
  const formatTime = timeString => {
    if (!timeString) {
      return "12:00";
    }
    const time = timeString.slice(0, 5);
    return time.length === 5 ? time : "12:00";
  };
  function formatDate(date) {
    const formattedDate = new Date(date);
    const month = `${formattedDate.getMonth() + 1}`;
    const day = `${formattedDate.getDate()}`;
    const year = formattedDate.getFullYear();
    return [year, month.padStart(2, "0"), day.padStart(2, "0")].join("-");
  }
  useEffect(() => {
    if (restaurant_id) {
      dispatch(fetchRestaurantDetails(restaurant_id));
    }
  }, [dispatch, restaurant_id]);
  useEffect(() => {
    const placeOfTables = zones.map(zone => zone.place_of_table);
    setZone_list(placeOfTables);
    if (!switchZones) {
      setSelectedZones(placeOfTables);
    }
  }, [zones, switchZones]);
  useEffect(() => {
    if (mode === "edit" && exceptions.length > 0 && exception_id) {
      const exception = exceptions.find(currentException => currentException.id === exception_id);
      if (exception) {
        const startDate = new Date(exception.closed_days_start);
        const endDate = exception.closed_days_end ? new Date(exception.closed_days_end) : startDate;
        setDateRange([{
          startDate,
          endDate,
          key: "selection"
        }]);
        setFormData({
          restaurant: parseInt(restaurant_id),
          closed_days_start: formatDate(startDate),
          closed_days_end: formatDate(endDate),
          start_time: formatTime(exception.start_time),
          end_time: formatTime(exception.end_time),
          list_of_zones: exception.list_of_zones || "",
          accept_people_per_each_time: exception.accept_people_per_each_time || "0",
          each_time: exception.each_time || "00:15",
          type_of_exception: exception.type_of_exception
        });
        setSelectedZones(exception.list_of_zones ? exception.list_of_zones.split(",") : []);
        setSwitchLimit(exception.type_of_exception === "limited");
        const placeOfTables = zones.map(zone => zone.place_of_table);
        const exceptionZones = exception.list_of_zones ? exception.list_of_zones.split(",") : [];
        setSwitchZones(exceptionZones.length < placeOfTables.length);
        setAaccept_people_per_each_time(parseInt(exception.accept_people_per_each_time || "0"));
        setEachTime(exception.each_time || "00:15");
      }
    }
    setIsFormReady(true);
  }, [mode, exceptions, exception_id, restaurant_id, zones]);
  const handleDateRangeChange = ranges => {
    setDateRange([ranges.selection]);
    setFormData(previousFormData => ({
      ...previousFormData,
      closed_days_start: formatDate(ranges.selection.startDate),
      closed_days_end: formatDate(ranges.selection.endDate)
    }));
  };
  const handleSelectZones = newSelectedItems => {
    setSelectedZones(newSelectedItems);
    setFormData(previousFormData => ({
      ...previousFormData,
      list_of_zones: newSelectedItems.join(",")
    }));
  };
  const handleSubmit = async event => {
    event.preventDefault();
    try {
      if (mode === "edit" && exception_id) {
        await api.put(`/restaurants/${restaurant_id}/OpenClosedExceptions/${exception_id}/`, formData);
      } else {
        await dispatch(createOpenClosedExceptions(restaurant_id, formData));
      }
      dispatch(fetchOpenClosedExceptions(restaurant_id));
      setShowModal(false);
    } catch (error) {
      console.error("Error submitting exception:", error);
    }
  };
  const handleExceptionElimination = async () => {
    try {
      await api.delete(`/restaurants/${restaurant_id}/OpenClosedExceptions/${exception_id}/`);
      dispatch(fetchOpenClosedExceptions(restaurant_id));
      setShowExceptionDaysDeleteModal(false);
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };
  if (!isFormReady) {
    return <Loader />;
  }
  return <div style={{
    margin: "0",
    padding: "0"
  }}>
      <div>
        <Form onSubmit={handleSubmit}>
          <FormGroup controlId="dateRange">
            <StyledLabel>{t("ui.components.restaurantSchedule.openClosedExceptions.dataDeInicioEDeFim")}</StyledLabel>

            <StyledDateRangePicker ranges={dateRange} onChange={handleDateRangeChange} minDate={new Date()} showDateDisplay={false} months={1} direction="horizontal" locale={dateLocale} />
          </FormGroup>

          <FormGroup controlId="timeRange">
            <StyledLabel>{t("ui.components.restaurantSchedule.openClosedExceptions.horario")}</StyledLabel>

            <TimeRangePicker startTime={formData.start_time} endTime={formData.end_time} onChange={times => {
            setFormData(previousFormData => ({
              ...previousFormData,
              start_time: times[0],
              end_time: times[1]
            }));
          }} />
          </FormGroup>

          {type_of_exception !== "closed_exception" && <>
              <FormGroup>
                <InsideFormGroup>
                  <StyledLabel>{t("ui.components.restaurantSchedule.openClosedExceptions.controlarChegadaDeClientes")}</StyledLabel>

                  <InlineText>{t("ui.components.restaurantSchedule.openClosedExceptions.permitirNoTotal")}</InlineText>

                  <BlockedInputWrapper $blocked={isArrivalControlBlocked}>
                    <Input type="number" id="accept_people_per_each_time" name="accept_people_per_each_time" value={displayedArrivalLimit} readOnly={isArrivalControlBlocked} aria-disabled={isArrivalControlBlocked} onChange={event => {
                  if (isArrivalControlBlocked) {
                    return;
                  }
                  const value = event.target.value;
                  setAaccept_people_per_each_time(value);
                  setFormData(previousFormData => ({
                    ...previousFormData,
                    accept_people_per_each_time: value
                  }));
                }} />

                    {isArrivalControlBlocked && <BlockedInputOverlay role="button" tabIndex={0} aria-label={t("ui.components.restaurantSchedule.openClosedExceptions.atualizarOPlanoParaAlterarO")} onClick={() => setShowArrivalControlUpgradeModal(true)} onKeyDown={event => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setShowArrivalControlUpgradeModal(true);
                  }
                }}>
                        <FontAwesomeIcon icon={faLock} />
                      </BlockedInputOverlay>}
                  </BlockedInputWrapper>

                  <InlineText>{t("ui.components.restaurantSchedule.openClosedExceptions.pessoasACada")}</InlineText>

                  <DropDownButton options={["00:15", "00:30", "00:45"]} handleOptionChange={selected => {
                setEachTime(selected);
                setFormData(previousFormData => ({
                  ...previousFormData,
                  each_time: selected
                }));
              }} initialOption={eachTime} />

                  <InlineText>{t("ui.components.restaurantSchedule.openClosedExceptions.minutos")}</InlineText>
                </InsideFormGroup>
              </FormGroup>

              <FormGroup controlId="zones">
                <StyledLabel>{t("ui.components.restaurantSchedule.openClosedExceptions.selecionarSalas")}</StyledLabel>

                <CustomSelectArray items={zone_list} onSelectChange={handleSelectZones} selectedItems={selectedZones} size="large" />
              </FormGroup>
            </>}

          <div style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px"
        }}>
            {mode === "edit" && <ModernButton color="#9fbbc1" onClick={() => setShowExceptionDaysDeleteModal(true)}>{t("ui.components.restaurantSchedule.openClosedExceptions.apagar")}</ModernButton>}

            <ModernButton color="#ff704d" type="submit">{t("ui.components.restaurantSchedule.openClosedExceptions.gravar")}</ModernButton>
          </div>
        </Form>
      </div>

      <ConfirmationModal show={showExceptionDaysDeleteModal} onHide={() => setShowExceptionDaysDeleteModal(false)} onConfirm={handleExceptionElimination} title={t("ui.components.restaurantSchedule.openClosedExceptions.eliminarExcecao")} body={t("ui.components.openClosedExceptions.temACertezaDeQueDeseja")} confirmLabel={t("ui.components.openClosedExceptions.eliminar")} cancelLabel={t("ui.components.openClosedExceptions.cancelar")} confirmColor="#ff704d" cancelColor="#9fbbc1" centered={false} topSpacing="250px auto" />

      <Modal show={showArrivalControlUpgradeModal} onHide={() => setShowArrivalControlUpgradeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ui.components.restaurantSchedule.openClosedExceptions.controlarChegadaDeClientes2")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p style={{
          margin: 0
        }}>{t("ui.components.restaurantSchedule.openClosedExceptions.aConfiguracaoDoTotalDePessoas")}</p>
        </Modal.Body>

        <Modal.Footer>
          <ModernButton color="#99b0ad" onClick={() => setShowArrivalControlUpgradeModal(false)}>{t("ui.components.restaurantSchedule.openClosedExceptions.agoraNao")}</ModernButton>

          <ModernButton color="#ee754c" onClick={() => {
          setShowArrivalControlUpgradeModal(false);
          navigate(`/pick_plan_and_pay/${restaurant_id}`);
        }}>{t("ui.components.restaurantSchedule.openClosedExceptions.verPlanos")}</ModernButton>
        </Modal.Footer>
      </Modal>
    </div>;
};
export default OpenClosedExceptions;
